import i18n from '../locales/i18n';

// Texto de sistema que o backend injeta DENTRO da resposta do assistente
// (bloco "Arquivos gerados", avisos entre parênteses, frases do fluxo de
// edição de skill, pergunta de confirmação de skill por contexto). Irmão de
// translateBackendError.js, e pela mesma decisão de desenho da feature
// i18n_erros_sistema: a tradução mora só aqui, no front.
//
// A diferença é que esse texto não chega num campo separado do JSON — ele é
// um pedaço da própria mensagem, intercalado com o que o modelo escreveu. Por
// isso o backend (backend/texto_i18n.py) manda o texto canônico em português
// embrulhado num comentário HTML que carrega a chave e os parâmetros:
//
//   <!-- i18n:skills.filesGenerated -->**Arquivos gerados:**<!-- /i18n -->
//   <!-- i18n:skills.editorIntro {"name":"x"} -->Vamos revisar...<!-- /i18n -->
//
// O miolo é o fallback: mensagem antiga (persistida antes desta mudança, sem
// marcador nenhum) passa direto, e chave que falte no arquivo de idioma cai no
// português em vez de sumir da tela.
const MARCADOR_I18N_RE = /<!--\s*i18n:([\w.]+)(?:\s+(\{[\s\S]*?\}))?\s*-->([\s\S]*?)<!--\s*\/i18n\s*-->/g;

function traduzirString(texto) {
    if (typeof texto !== 'string' || !texto.includes('<!-- i18n:')) {
        return texto;
    }

    return texto.replace(MARCADOR_I18N_RE, (_bruto, chave, paramsJson, fallback) => {
        let params = {};
        if (paramsJson) {
            try {
                params = JSON.parse(paramsJson);
            } catch (e) {
                // Marcador corrompido (ex.: nome de skill que escapou da
                // sanitização do backend) não pode comer o texto: segue sem
                // interpolação e, se a chave precisar de um parâmetro que não
                // veio, o fallback em português cobre.
                params = {};
            }
        }
        return i18n.t(chave, { ns: 'chat', defaultValue: fallback, ...params }) || fallback;
    });
}

// `content` de mensagem é string na resposta do assistente, mas pode ser a
// lista de content blocks ({type, text}) que o chat usa noutros pontos - os
// dois formatos passam por aqui porque o componente não distingue antes.
export function translateInlineText(content) {
    if (Array.isArray(content)) {
        return content.map((bloco) =>
            bloco && bloco.type === 'text' && typeof bloco.text === 'string'
                ? { ...bloco, text: traduzirString(bloco.text) }
                : bloco
        );
    }
    return traduzirString(content);
}
